import { Button } from '../atoms/Button/Button';
import { useTranslation } from '../../i18n/useTranslation';
import './LikeButton.css';

export interface LikeButtonProps {
  liked: boolean;
  count: number;
  onToggle: () => void;
  pending?: boolean;
  /** What is liked, for the accessible name (e.g. the entry title). */
  subject?: string;
}

/**
 * Toggle for a like (journal entry or image). State is aria-pressed plus the
 * filled/outlined heart and the text, never colour alone.
 */
export function LikeButton({ liked, count, onToggle, pending = false, subject }: LikeButtonProps) {
  const { t } = useTranslation();
  return (
    <Button
      type="button"
      variant="secondary"
      size="sm"
      className={`rg-like-button${liked ? ' rg-like-button--liked' : ''}`}
      aria-pressed={liked}
      aria-label={subject ? t('community.likeSubject', { subject, count }) : t('community.likeCount', { count })}
      onClick={onToggle}
      disabled={pending}
      data-testid="like-button"
    >
      <span aria-hidden="true" className="rg-like-button__icon">{liked ? '♥' : '♡'}</span>
      <span aria-hidden="true">{t('community.like')}</span>
      <span aria-hidden="true" className="rg-like-button__count">{count}</span>
    </Button>
  );
}

export default LikeButton;
